<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret produkt
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="namegroup">
											<label for="name">
												Navn
											</label>
											<input v-model="name" type="text" ref="name" value>
										</div>

										<div class="input-group" ref="typegroup">
											<label for="status">
												Produkt type
											</label>
											<select v-model="type" ref="type">
												<option value="1">Portræt</option>
												<option value="2">Gruppefoto</option>
												<option value="3">Video</option>
												<option value="4">USB stick</option>
												<option value="5">Bog</option>
												<option value="6">Andet</option>
											</select><span></span>
										</div>
									</div>

									<div class="form-group">

										<div class="input-group" ref="descriptiongroup">
											<label for="description">
												Beskrivelse
											</label>
											<textarea v-model="description" name="description" ref="description" class="large"></textarea>
										</div>
									</div>

								</div>

								<div class="form-groups">
									<div class="form-group">
										<div class="input-group-hori">
											<div class="input-group" ref="widthgroup">
												<label for="width">
													Bredde
												</label>
												<input v-model="width" type="text" ref="width" value>
											</div>
											<div class="input-group" ref="heightgroup">
												<label for="height">
													Højde
												</label>
												<input v-model="height" type="text" ref="height" value>
											</div>
										</div>

										<div class="input-group" ref="lengthgroup">
											<label for="length">
												Længde
											</label>
											<input v-model="length" type="text" ref="length" value>
										</div>
									</div>
								</div>
								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="deleteData" class="delete left" v-if="dialogMode == 'edit'">
										Slet
									</button>
									<button type="button" @click.prevent="close" class="text space">
										Tilbage
									</button>
									<button type="button" @click.prevent="saveData">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";

	export default {
		name: "ProductEdit",
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret produkt",
				productID: "0",

				name: "",
				type: "1",
				description: "",
				width: "",
				height: "",
				length: "",
				product: {
					name: "",
					type: "1",
					description: "",
					width: "",
					height: "",
					length: "",
				},
			}
		},
		mounted()
		{
			this.setModalIsVisible()

			if (this.$route.name == "ProductEdit")
			{
				this.dialogMode = "edit"
				this.dialogTitle = "Rediger produkt"
				this.productID = this.$route.params.productid
				this.loadData()
			}
			else
			{
				this.dialogMode = "create"
				this.dialogTitle = "Opret produkt"
				this.$refs.name.focus()
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		methods:
		{
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.name != this.product.name)
				changes = changes || (this.type != this.product.type)
				changes = changes || (this.description != this.product.description)
				changes = changes || (this.height != this.product.height)
				changes = changes || (this.width != this.product.width)
				changes = changes || (this.length != this.product.length)

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false;
			},
			close()
			{
				if (this.checkForChanges())
				{
					return;
				}

				this.$router.push({ name: "ProductsList" })
			},
			async loadData()
			{
				if (this.productID)
				{
					this.setAppAsBusyModal();

					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_PRODUCT, this.productID);

						if (result.status == 200)
						{
							this.product = result.data;
							this.name = result.data.name
							this.type = result.data.type
							this.description = result.data.description
							this.height = result.data.height
							this.width = result.data.width
							this.length = result.data.length
							this.setAppAsIdle()
						}
						else
						{
							this.setAppAsIdle()
							logError("ProductEdit.loadData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
							this.$router.push({ name: "ProductsList" })
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("ProductEdit.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "ProductsList" })
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen. 6");
					this.$router.push({ name: "ProductsList" })
				}
			},
			async saveData()
			{
				try
				{
					var valid = true
					var validationFocus = false

					if (this.name.length == 0)
					{
						this.$refs.namegroup.setAttribute("data-validation", "Indtast venligst et navn")
						this.$refs.name.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.namegroup.removeAttribute("data-validation")
					}

					if (this.height && this.height.length != 0 && isNaN(this.height))
					{
						this.$refs.heightgroup.setAttribute("data-validation", "Indtast venligst en højde i tal")
						this.$refs.height.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.heightgroup.removeAttribute("data-validation")
					}

					if (this.width && this.width.length != 0 && isNaN(this.width))
					{
						this.$refs.widthgroup.setAttribute("data-validation", "Indtast venligst en bredde i tal")
						this.$refs.width.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.widthgroup.removeAttribute("data-validation")
					}

					if (this.length && this.length.length != 0 && isNaN(this.length))
					{
						this.$refs.lengthgroup.setAttribute("data-validation", "Indtast venligst en længde i tal")
						this.$refs.length.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.lengthgroup.removeAttribute("data-validation")
					}

					if (!valid)
					{
						return;
					}

					this.setAppAsBusyModal()

					var data =
					{
						id: this.productID,
						name: this.name,
						type: this.type,
						height: this.height,
						width: this.width,
						length: this.length
					}

					if (this.dialogMode == "edit")
					{
						var result = await this.$store.dispatch(types.ACTION_UPDATE_PRODUCT, data);

						if (result.status == 200)
						{
							this.product = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
							this.$router.push({ name: "ProductsList" })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle();

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede et produkt med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message);
								alert("Der opstod en fejl. Opdater siden og prøv igen.");
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("Product.saveData()", result.status)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
					else
					{
						var result = await this.$store.dispatch(types.ACTION_ADD_PRODUCT, data);

						if (result.status == 201)
						{
							this.product = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.ADDED)
							this.$router.push({ name: "ProductsList" })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle();

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede et produkt med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message);
								alert("Der opstod en fejl. Opdater siden og prøv igen.");
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("Product.saveData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
				}
				catch (ex)
				{
					this.showErrorAlert(ex)
					this.setAppAsIdle()
				}
			},
			async deleteData()
			{
				if (confirm("Er du sikker? Sletningen kan ikke fortrydes."))
				{
					try
					{
						await this.$store.dispatch(types.ACTION_DELETE_PRODUCT, this.productID)
							.then(response =>
							{
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.$router.push({ name: "ProductsList" })
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Product.deleteData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
							});
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("Product.deleteData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "ProductsList" })
					}
				}
			},
		}
	};
</script>